import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FaFilter, 
  FaSearch, 
  FaStar, 
  FaUsers, 
  FaClock, 
  FaGraduationCap,
  FaArrowRight,
  FaBookOpen,
  FaLaptopCode,
  FaChartBar,
  FaBriefcase,
  FaHeart,
  FaPlay
} from 'react-icons/fa';

const LXDCourses = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedLevel, setSelectedLevel] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredCourses, setFilteredCourses] = useState([]);

  const categories = [
    { name: 'All', icon: <FaBookOpen /> },
    { name: 'Technology', icon: <FaLaptopCode /> },
    { name: 'Business', icon: <FaBriefcase /> },
    { name: 'Data Science', icon: <FaChartBar /> },
    { name: 'Design', icon: <FaHeart /> }
  ];

  const levels = ['All', 'Beginner', 'Intermediate', 'Advanced'];

  const courses = [
    {
      id: 1,
      title: "Digital Marketing Mastery",
      category: "Business",
      level: "Beginner",
      duration: "8 weeks",
      students: 2340,
      rating: 4.8,
      reviews: 342,
      price: "Free",
      originalPrice: "Birr 3,000",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400",
      instructor: "Dr. Abebe Kebede",
      instructorAvatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100",
      description: "Master digital marketing strategies tailored for Ethiopian businesses. Learn SEO, social media marketing, and content creation.",
      tags: ["Marketing", "SEO", "Social Media"],
      isBestseller: true,
      isNew: false
    },
    {
      id: 2,
      title: "Web Development Bootcamp",
      category: "Technology",
      level: "Intermediate",
      duration: "12 weeks",
      students: 1890,
      rating: 4.9,
      reviews: 456,
      price: "Birr 5,000",
      originalPrice: "Birr 8,000",
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=400",
      instructor: "Eng. Selamawit Bekele",
      instructorAvatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100",
      description: "Full-stack web development with React, Node.js, and MongoDB. Build real-world projects for Ethiopian market.",
      tags: ["Web Dev", "React", "Node.js"],
      isBestseller: true,
      isNew: false
    },
    {
      id: 3,
      title: "Data Science with Python",
      category: "Data Science",
      level: "Advanced",
      duration: "16 weeks",
      students: 1450,
      rating: 4.7,
      reviews: 234,
      price: "Birr 7,500",
      originalPrice: "Birr 12,000",
      image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400",
      instructor: "Prof. Dawit Haile",
      instructorAvatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100",
      description: "Advanced data science techniques including machine learning, deep learning, and data visualization for Ethiopian datasets.",
      tags: ["Python", "ML", "AI"],
      isBestseller: false,
      isNew: true
    },
    {
      id: 4,
      title: "Entrepreneurship in Ethiopia",
      category: "Business",
      level: "Beginner",
      duration: "6 weeks",
      students: 3200,
      rating: 4.9,
      reviews: 567,
      price: "Free",
      originalPrice: "Birr 2,000",
      image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=400",
      instructor: "Mrs. Tigist Haile",
      instructorAvatar: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100",
      description: "Start and grow your business in Ethiopia. Learn from successful Ethiopian entrepreneurs and industry experts.",
      tags: ["Business", "Startup", "Finance"],
      isBestseller: true,
      isNew: false
    },
    {
      id: 5,
      title: "UI/UX Design Fundamentals",
      category: "Design",
      level: "Beginner",
      duration: "10 weeks",
      students: 980,
      rating: 4.6,
      reviews: 123,
      price: "Birr 4,000",
      originalPrice: "Birr 6,500",
      image: "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400",
      instructor: "Alemnesh Tadesse",
      instructorAvatar: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100",
      description: "Create beautiful and functional user interfaces. Learn design thinking, prototyping, and user research methods.",
      tags: ["UI/UX", "Design", "Figma"],
      isBestseller: false,
      isNew: true
    },
    {
      id: 6,
      title: "Mobile App Development",
      category: "Technology",
      level: "Intermediate",
      duration: "14 weeks",
      students: 1200,
      rating: 4.8,
      reviews: 189,
      price: "Birr 6,000",
      originalPrice: "Birr 10,000",
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=400",
      instructor: "Kibru Mekonnen",
      instructorAvatar: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100",
      description: "Build native mobile apps for iOS and Android using React Native. Create apps for the Ethiopian market.",
      tags: ["Mobile", "React Native", "iOS"],
      isBestseller: false,
      isNew: false
    },
    {
      id: 7,
      title: "Financial Accounting",
      category: "Business",
      level: "Beginner",
      duration: "8 weeks",
      students: 2100,
      rating: 4.5,
      reviews: 278,
      price: "Birr 3,500",
      originalPrice: "Birr 5,000",
      image: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=400",
      instructor: "Dr. Mulugeta Abebe",
      instructorAvatar: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100",
      description: "Master financial accounting principles and practices. Learn Ethiopian tax regulations and financial reporting.",
      tags: ["Accounting", "Finance", "Tax"],
      isBestseller: false,
      isNew: false
    },
    {
      id: 8,
      title: "Machine Learning Specialization",
      category: "Data Science",
      level: "Advanced",
      duration: "20 weeks",
      students: 750,
      rating: 4.9,
      reviews: 145,
      price: "Birr 10,000",
      originalPrice: "Birr 15,000",
      image: "https://images.unsplash.com/photo-1555949963-aa79dcee981c?w=400",
      instructor: "Dr. Elias Tesfaye",
      instructorAvatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100",
      description: "Deep dive into machine learning algorithms. Build predictive models for Ethiopian business and healthcare sectors.",
      tags: ["ML", "AI", "Python"],
      isBestseller: true,
      isNew: true
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  const filterCourses = () => {
    return courses.filter(course => {
      const matchesCategory = selectedCategory === 'All' || course.category === selectedCategory;
      const matchesLevel = selectedLevel === 'All' || course.level === selectedLevel;
      const matchesSearch = course.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           course.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           course.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()));
      return matchesCategory && matchesLevel && matchesSearch;
    });
  };

  const displayedCourses = filterCourses();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 pt-24">
      {/* Header Section */}
      <section className="bg-gradient-to-r from-purple-600 via-blue-600 to-cyan-500 text-white py-16">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            className="text-center"
          >
            <h1 className="text-4xl lg:text-6xl font-bold mb-4">
              Explore Our Courses
            </h1>
            <p className="text-xl text-white/90 max-w-2xl mx-auto">
              Discover world-class courses designed for Ethiopian learners. Transform your career with industry-relevant skills.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Search and Filter Section */}
      <section className="container mx-auto px-6 py-8">
        <div className="bg-white rounded-2xl shadow-xl p-6 -mt-8 relative z-10">
          <div className="flex flex-col lg:flex-row gap-4">
            {/* Search Bar */}
            <div className="flex-1 relative">
              <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search courses, topics, or instructors..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500"
              />
            </div>

            {/* Category Filter */}
            <div className="relative">
              <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="appearance-none px-4 py-3 pr-10 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white cursor-pointer"
              >
                {categories.map(cat => (
                  <option key={cat.name} value={cat.name}>{cat.name}</option>
                ))}
              </select>
              <FaFilter className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
            </div>

            {/* Level Filter */}
            <div className="relative">
              <select
                value={selectedLevel}
                onChange={(e) => setSelectedLevel(e.target.value)}
                className="appearance-none px-4 py-3 pr-10 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-500 bg-white cursor-pointer"
              >
                {levels.map(level => (
                  <option key={level} value={level}>{level} Level</option>
                ))}
              </select>
              <FaGraduationCap className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none" />
            </div>
          </div>
        </div>
      </section>

      {/* Category Pills */}
      <section className="container mx-auto px-6 py-4">
        <div className="flex flex-wrap gap-3">
          {categories.map((category) => (
            <motion.button
              key={category.name}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => setSelectedCategory(category.name)}
              className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all ${
                selectedCategory === category.name
                  ? 'bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-lg'
                  : 'bg-white text-gray-700 hover:bg-purple-50 border border-gray-200'
              }`}
            >
              {category.icon}
              <span className="font-medium">{category.name}</span>
            </motion.button>
          ))}
        </div>
      </section>

      {/* Courses Grid */}
      <section className="container mx-auto px-6 py-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800">
            {displayedCourses.length} Courses Found
          </h2>
          <select className="px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500">
            <option>Most Popular</option>
            <option>Newest</option>
            <option>Price: Low to High</option>
            <option>Price: High to Low</option>
            <option>Highest Rated</option>
          </select>
        </div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        >
          {displayedCourses.map((course) => (
            <motion.div
              key={course.id}
              variants={itemVariants}
              whileHover={{ y: -10 }}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              <div className="relative">
                <img
                  src={course.image}
                  alt={course.title}
                  className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 flex gap-2">
                  {course.isBestseller && (
                    <span className="bg-yellow-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      Bestseller
                    </span>
                  )}
                  {course.isNew && (
                    <span className="bg-green-500 text-white px-3 py-1 rounded-full text-xs font-semibold">
                      New
                    </span>
                  )}
                </div>
                <div className="absolute top-4 right-4 bg-white/90 backdrop-blur px-2 py-1 rounded-full text-sm font-semibold flex items-center gap-1">
                  <FaStar className="text-yellow-500" />
                  {course.rating}
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <Link
                    to={`/courses/${course.id}`}
                    className="bg-white text-purple-600 px-6 py-3 rounded-full font-semibold hover:bg-purple-50 transition-all flex items-center gap-2"
                  >
                    <FaPlay /> Preview
                  </Link>
                </div>
              </div>
              
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <img
                    src={course.instructorAvatar}
                    alt={course.instructor}
                    className="w-8 h-8 rounded-full object-cover"
                  />
                  <span className="text-sm text-gray-600">{course.instructor}</span>
                </div>
                
                <h3 className="font-bold text-lg text-gray-800 mb-2 line-clamp-2 group-hover:text-purple-600 transition-colors">
                  {course.title}
                </h3>
                
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-3">
                  <span className="bg-blue-100 text-blue-700 px-2 py-1 rounded">
                    {course.level}
                  </span>
                  <span>•</span>
                  <span className="flex items-center gap-1">
                    <FaClock /> {course.duration}
                  </span>
                </div>
                
                <div className="flex items-center gap-2 text-sm text-gray-600 mb-4">
                  <FaUsers className="text-purple-600" />
                  <span>{course.students.toLocaleString()} students</span>
                  <span>•</span>
                  <span>{course.reviews} reviews</span>
                </div>
                
                <div className="flex flex-wrap gap-2 mb-4">
                  {course.tags.map((tag, index) => (
                    <span key={index} className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded">
                      {tag}
                    </span>
                  ))}
                </div>
                
                <div className="flex items-center justify-between pt-4 border-t">
                  <div>
                    {course.originalPrice && (
                      <div className="text-sm text-gray-400 line-through">{course.originalPrice}</div>
                    )}
                    <div className="text-xl font-bold text-purple-600">{course.price}</div>
                  </div>
                  <Link
                    to={`/courses/${course.id}`}
                    className="bg-gradient-to-r from-purple-600 to-blue-600 text-white px-4 py-2 rounded-xl font-semibold hover:opacity-90 transition-all flex items-center gap-2"
                  >
                    Enroll <FaArrowRight />
                  </Link>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {displayedCourses.length === 0 && (
          <div className="text-center py-16">
            <FaBookOpen className="text-6xl text-gray-300 mx-auto mb-4" />
            <h3 className="text-2xl font-bold text-gray-600 mb-2">No courses found</h3>
            <p className="text-gray-500">Try adjusting your filters or search query</p>
          </div>
        )}
      </section>

      {/* CTA Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-purple-600 to-blue-600 rounded-3xl p-12 text-center text-white"
          >
            <h2 className="text-3xl lg:text-4xl font-bold mb-4">
              Can't Find What You're Looking For?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              We're constantly adding new courses. Subscribe to get notified about new releases.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-6 py-3 rounded-full text-gray-800 focus:outline-none"
              />
              <button className="bg-white text-purple-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-all">
                Subscribe
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default LXDCourses;
